import { useMutation } from 'react-query';
import { KA_API_ROOT_URL } from '../../config/baseUrl';
import axios from '../../utils/axios-client';

/**
 * Requests
 */

const registerShopifyMerchant = async (shop, nonce, email, password) =>
  axios.post(
    `${KA_API_ROOT_URL}/shopify/register`,
    { email, password },
    { params: { shopify_shop: shop, shopify_state: nonce } },
  );

const createShopifySubscription = async () => axios.post(`${KA_API_ROOT_URL}/shopify/subscription`);

/**
 * Hooks
 */

export const useRegisterShopifyMerchant = mutationConfig =>
  useMutation(async ({ shop, nonce, email, password }) => {
    const response = await registerShopifyMerchant(shop, nonce, email, password);
    return response?.data ?? {};
  }, mutationConfig);

export const useCreateShopifySubscription = mutationConfig =>
  useMutation(async () => {
    const response = await createShopifySubscription();
    return response?.data ?? {};
  }, mutationConfig);
